import {
  Facebook,
  Instagram,
  Tiktok,
  Youtube,
} from '@time-line/components/icons';
import type { ReactNode } from 'react';

import type { SocialLink } from './organization';
import { SOCIAL_LINKS } from './organization';

export interface SocialProfile extends SocialLink {
  icon: ReactNode;
}

const ICONS: Record<SocialLink['name'], ReactNode> = {
  instagram: <Instagram color="blackAlpha.700" boxSize="xs" />,
  facebook: <Facebook color="blackAlpha.700" boxSize="xs" />,
  youtube: <Youtube color="blackAlpha.700" boxSize="xs" />,
  tiktok: <Tiktok color="blackAlpha.700" boxSize="xs" />,
};

export const SOCIAL_PROFILES: readonly SocialProfile[] = SOCIAL_LINKS.map(
  (link) => ({ ...link, icon: ICONS[link.name] }),
);
